import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function ViewPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { imageName, userEmail } = location.state; // Destructure imageName and userEmail from state

  // Corrected URL string for fetching the image
  const imageUrl = `/flask_static/${userEmail}/Rosaf/${imageName}?t=${new Date().getTime()}`;

  const handleReplace = () => {
    // Navigate to the EditPage with the imageName and userEmail
    navigate('/EditPage', { state: { imageName, userEmail } });
  };

  const handleBack = () => {
    navigate(-1); // Navigate back to the previous page
  };

  return (
    <div
      style={{
        padding: '20px',
        textAlign: 'center',
        background: 'linear-gradient(to bottom, #fff7ad, #ffa9f9)',
        minHeight: '100vh',
      }}
    >
      {/* Heading in pink color */}
      <h2 style={{ color: '#E11584' }}>View Image: {imageName}</h2>

      {/* Display the clicked image */}
      <div style={{ margin: '20px auto' }}>
        <img
          src={imageUrl} // Use the updated imageUrl with timestamp
          alt={imageName}
          style={{ width: '300px', height: '300px', borderRadius: '8px' }}
        />
      </div>

      {/* Replace and Back buttons in pink color */}
      <button
        onClick={handleReplace}
        style={{
          backgroundColor: '#E11584',
          color: 'black',
          padding: '15px 30px',
          fontSize: '16px',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          margin: '10px',
        }}
      >
        Replace
      </button>

      <button
        onClick={handleBack}
        style={{
          backgroundColor: '#E11584',
          color: 'black',
          padding: '15px 30px',
          fontSize: '16px',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          margin: '10px',
        }}
      >
        Back
      </button>
    </div>
  );
}

export default ViewPage;
